import { connect } from 'react-redux';
import React, { useCallback } from 'react';
import { Header } from '@pipltrust/apps-components';
import PropTypes from 'prop-types';
import { useCookies } from 'react-cookie/es6';
import { AppSelectors } from '../../Redux/modules/app/selectors';
import { AppActions } from '../../Redux/modules/app/actions';
import AppConfig from '../../Config/AppConfig';
import styles from '../Header/Header.module.less';
import Banner from '../Banner/Banner';

const HeaderContainer = (props) => {
  const { user, isLogged, isAdmin, isOnBoardingVerifyAPI, hasApiContext, eventTrackingFunction } = props;
  const [cookies] = useCookies([]);
  const csrfToken = cookies[AppConfig.CSRF_COOKIE_NAME];

  const contextApp = hasApiContext ? 'devportal' : 'searchInsights';
  const switchAppLink = hasApiContext ? AppConfig.INSIGHTS_SEARCH_HISTORY_URL : AppConfig.API_USAGE_URL;
  const urlPrefix = hasApiContext ? '/api' : '';
  const profileUrl = `${urlPrefix}/accounts/profile/`;
  const organizationUrl = `${urlPrefix}/accounts/organization/`;
  const handleLogout = useCallback(async () => {
    const url = `/${AppConfig.ACCOUNTS_PREFIX}logout/?next=${window.location.pathname}`;

    await fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRFTOKEN': csrfToken,
      },
    });

    window.location.href = `/${AppConfig.ACCOUNTS_PREFIX}login/`;
  }, []);
  const newUser = { ...user, isAdmin, name: `${user.firstName} ${user.lastName}` };
  const shouldDisplayHeader = isLogged && !isOnBoardingVerifyAPI;

  return (
    shouldDisplayHeader && (
      <div className={styles.headerContainer}>
        <Banner cookies={cookies} />
        <Header
          user={newUser}
          isSignedIn={isLogged}
          hasSideMenu={false}
          onSignOut={() => handleLogout()}
          linksObjects={[]}
          csrfToken={csrfToken}
          helpLink={hasApiContext ? AppConfig.API_HELP_LINK : AppConfig.HELP_LINK}
          contextApp={contextApp}
          switchAppLink={switchAppLink}
          profileUrl={profileUrl}
          organizationUrl={organizationUrl}
          eventTrackingFunction={eventTrackingFunction}
        />
      </div>
    )
  );
};

HeaderContainer.propTypes = {
  isLogged: PropTypes.bool,
  isOnBoardingVerifyAPI: PropTypes.bool,
  user: PropTypes.object,
  isAdmin: PropTypes.bool,
  hasApiContext: PropTypes.bool,
  eventTrackingFunction: PropTypes.func,
};
const mapStateToProps = (state) => {
  return {
    user: AppSelectors.userSelector(state),
    isLogged: AppSelectors.isLoggedSelector(state),
    isOnBoardingVerifyAPI: AppSelectors.isOnBoardingVerifyAPISelector(state),
    isAdmin: AppSelectors.isOrgAdminSelector(state),
    hasApiContext: AppSelectors.hasApiContextSelector(state),
  };
};
const mapDispatchToProp = {
  eventTrackingFunction: AppActions.eventTracking,
};

export default connect(mapStateToProps, mapDispatchToProp)(HeaderContainer);
